import { MatFormFieldAppearance } from '@angular/material/form-field';
import { Component, EventEmitter, Inject, Input, Output, OnInit, OnDestroy } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Observable, Subject, Subscription, tap, debounceTime, takeUntil } from 'rxjs';
import { L10N_LOCALE, L10nLocale } from 'angular-l10n';

@Component({
  selector: 'app-suggest-search-box',
  templateUrl: './suggest-search-box.component.html',
  styleUrl: './suggest-search-box.component.scss',
  standalone: false
})
export class SuggestSearchBoxComponent implements OnInit, OnDestroy {
  @Input() label: string;
  @Input() placeholder: string;
  @Input() field: string;
  @Input() control: FormControl<string>;
  @Input() styles: Record<string, string> = {};
  @Input() appearance: MatFormFieldAppearance = 'fill';
  @Input() suggestApi: (field: string, value: string) => Observable<string[]>;

  @Output() selectedValue = new EventEmitter<string>();

  suggestions: string[] = [];
  destroy$ = new Subject<void>();

  constructor(@Inject(L10N_LOCALE) public locale: L10nLocale) {}

  ngOnInit(): void {
    this.control?.valueChanges.pipe(debounceTime(300), tap(this.onShowSuggestions.bind(this)), takeUntil(this.destroy$)).subscribe();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  previousQuery = undefined;
  previousRx: Subscription = undefined;
  onShowSuggestions(query: string): void {
    if (query === this.previousQuery) {
      return;
    }

    if (this.previousRx) {
      this.previousRx.unsubscribe();
    }

    this.previousRx = this.suggestApi(this.field, query)
      .pipe(tap((suggestions) => (this.suggestions = suggestions)))
      .subscribe();

    this.previousQuery = query;
  }
}
